// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

// UI
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// Data
import "./firebaseSetup.js"; // this is my local file with my personal API key etc
import vuefire from "vuefire"; // #### I THINK WE ARE NOT USING THIS?
import { BootstrapVue } from "bootstrap-vue";

// v-calendar
import VCalendar from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";

// App's actual components
import App from "./components/App.vue";

// font-awesome. Three imports, a library.add, and a Vue.use of two things From https://fontawesome.com/how-to-use/on-the-web/using-with/vuejs
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHandshake,
  faPeopleCarry,
  faChevronCircleLeft,
  faHome,
  faList,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faHandshake,
  faPeopleCarry,
  faChevronCircleLeft,
  faHome,
  faList,
  faPhone
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

/* eslint-disable no-new */
// Vue.use(VueRouter);
Vue.use(vuefire);
Vue.use(BootstrapVue);
Vue.use(VCalendar, { firstDayOfWeek: 2 });

new Vue({
  el: "#app",
  template: "<App></App>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js